import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ExternalPageComponent} from "./external-page/external-page.component";

const routes: Routes = [
  {
    path: ':lang',
    children: [
      {
        path: '',
        component: ExternalPageComponent,
        data: {
          presetSlug: 'home'
        }
      },
      {
        path: 'home',
        redirectTo: ''
      },
      {
        path: 'date',
        loadComponent: () => import('./date-selector-page/date-selector-page.component').then(m => m.DateSelectorPageComponent)
      },
      {
        path: 'vehicle-consultation/date',
        loadComponent: () => import('./vehicle-date-selector-page/vehicle-date-selector-page.component').then(m => m.VehicleDateSelectorPageComponent)
      },
      {
        path: 'articles',
        loadComponent: () => import('./article-page/articles-page.component').then(m => m.ArticlesPageComponent)
      },
      {
        path: 'vehicle-consultation/vehicles',
        loadComponent: () => import('./vehicle-articles-page/vehicles-page.component').then(m => m.VehiclesPageComponent)
      },
      {
        path: 'summary',
        loadComponent: () => import('./cart-summary-page/cart-summary-page.component').then(m => m.CartSummaryPageComponent)
      },
      {
        path: 'order',
        loadComponent: () => import('./order-page/order-page.component').then(m => m.OrderPageComponent)
      },
      {
        path: 'payment',
        loadChildren: () => import('./payment/payment-page-routing.module').then(m => m.PaymentPageRoutingModule)
      },
      {
        path: 'thank-you',
        loadComponent: () => import('./thank-you-page/thank-you-page.component').then(m => m.ThankYouPageComponent)
      },
      {
        path: 'booking',
        loadChildren: () => import('./booking-edit-page/booking-edit-page-routing.module').then(m => m.BookingEditPageRoutingModule)
      },
      {
        path: 'vehicle-consultation/online-meeting',
        loadComponent: () => import('./vehicle-online-waiting-page/vehicle-online-waiting-page.component').then(m => m.VehicleOnlineWaitingPageComponent)
      },
      {
        path: 'online-workshop/meeting',
        loadComponent: () => import('./online-workshop-waiting-page/online-workshop-waiting-page.component').then(m => m.OnlineWorkshopWaitingPageComponent)
      },
      {
        path: 'cookies',
        loadComponent: () => import('./cookies-page/cookies-page.component').then(m => m.CookiesPageComponent)
      },
      {
        path: '404',
        loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent)
      },
      {
        path: '**',
        component: ExternalPageComponent,
      }
    ]
  },
  // Redirect the root path to the default language prefix
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   redirectTo: '/en'
  // },
  // Redirect invalid paths to the default language prefix
  // {
  //   path: '**',
  //   redirectTo: '/en'
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
      enableTracing: false,
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'disabled',
      paramsInheritanceStrategy: 'always',
      canceledNavigationResolution: 'replace', // Default
      urlUpdateStrategy: 'deferred', // Default
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
